var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BilletInfo } from "@/components/common/BilletInfo";
import { Container } from "@/components/common/Container";
import { EvaluateServiceButton } from "@/components/common/EvaluateServiceButton";
import { PageTitle } from "@/components/common/PageTitle";
import { RequestProof } from "@/components/common/RequestProof";
import { ServiceInfo, ServiceInfoItem } from "@/components/common/ServiceInfo";
import { useStepperControl } from "@/hooks/useStepperControl";
import GatewayService from "@/services/api/GatewayService";
import { TriangleAlert } from "lucide-react";
import { useState } from "react";
import { DialogBoletoDetails } from "./components/DialogBoletoDetails";
import { MerchanApp } from "@/components/common/MerchanApp";
import { Breadcrumbs } from "@/components/common/Breadcrumbs";
var BREADCRUMB_ITEMS = [
    {
        name: "Página Inicial",
        path: "https://portal.pi.gov.br/detran/",
    },
    {
        name: "Solicitar CNH Definitiva",
        path: "/",
    },
    {
        name: "Pagamento da taxa",
        path: "/",
        current: true,
    },
];
export function Tax() {
    var service = new GatewayService();
    var _a = useState(false), showBoleto = _a[0], setShowBoleto = _a[1];
    var serviceReturn = useStepperControl().serviceReturn;
    return (_jsxs(Container, { children: [_jsx(Breadcrumbs, { pages: BREADCRUMB_ITEMS }), _jsx(PageTitle, { title: "Troca de CNH Permission\u00E1ria para Definitiva" }), _jsxs("div", __assign({ className: "w-full max-w-[856px] flex flex-col gap-2" }, { children: [_jsx(ServiceInfo, { children: _jsx(ServiceInfoItem, { title: "Sua solicita\u00E7\u00E3o foi criada!", content: [
                                "Paga a taxa pendente abaixo para validar sua solicitação:",
                            ], listType: "none" }) }), _jsx(BilletInfo, { serviceName: "Troca de CNH Permission\u00E1ria para Definitiva", data: serviceReturn, handleShowBoleto: setShowBoleto })] })), _jsxs("section", __assign({ className: "w-full max-w-[856px] bg-light-yellow-alert flex flex-col justify-between px-6 py-3 rounded-lg" }, { children: [_jsxs("div", __assign({ className: "flex items-center gap-2 py-2" }, { children: [_jsx(TriangleAlert, { className: "text-black-900" }), _jsx("span", __assign({ className: "font-medium text-center" }, { children: "Aten\u00E7\u00E3o!" }))] })), _jsx("p", __assign({ className: "font-light" }, { children: "Caso o pagamento n\u00E3o seja confirmado em at\u00E9 15 dias, o protocolo ser\u00E1 CANCELADO automaticamente." }))] })), _jsx("section", __assign({ className: "hidden lg:block w-full max-w-[856px] rounded-lg p-6 border-l-2 border-r-2 border-t-2 border-b-2 bg-light-blue-100 space-y-6" }, { children: _jsx(RequestProof, { serviceReturn: serviceReturn }) })), _jsx("section", { children: _jsx(MerchanApp, {}) }), _jsx(EvaluateServiceButton, {}), _jsx(DialogBoletoDetails, { serviceReturn: serviceReturn, service: service, showBoleto: showBoleto, setShowBoleto: setShowBoleto })] }));
}
